<template>
  <ul class="products-listing">
    <li v-for="(item, i) in items" :key="i" class="products-listing__card card">
      <div class="card-body" @click="$emit('item-selected', item)" v-if="product(item.productId)">
        <ProductImage :path="product(item.productId).img" class="products-listing__product-image" />
        <div>
          <span class="badge badge-primary badge-pill products-listing__amount">{{ item.amount }}x</span>
          <ExpiryDateBadge v-if="item.expiryDate" :expiryDate="item.expiryDate" class="products-listing__expiry-date" />
        </div>
      </div>
      <small class="text-danger text-center pt-5" v-else>Product {{ item.productId }} not found</small>
    </li>
    <li
      v-if="showAddOptions"
      class="products-listing__card products-listing__card--add-option card"
      @click="$emit('add-option')"
    >
      +
    </li>
  </ul>
</template>

<script>
import ProductImage from '@/components/ProductImage'
import ExpiryDateBadge from '@/components/ExpiryDateBadge'

export default {
  components: { ProductImage, ExpiryDateBadge },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showAddOptions: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    product(id) {
      return _.find(this.$store.state.products, { id })
    }
  }
}
</script>

<style lang="scss" scoped>
.products-listing {
  display: flex;
  flex-wrap: wrap;

  margin: 0;
  padding: 0;

  &__card {
    margin: 0 1rem 1rem 0;
    width: calc(33.333% - 1rem);
    height: 11.25rem;

    &--add-option {
      cursor: pointer;

      color: #aaa;
      font-size: 4rem;
      font-weight: bold;
      line-height: 11.25rem;
      text-align: center;
    }
  }

  &__product-image {
    width: 100%;
    margin: 0;
  }

  &__amount {
    position: absolute;
    left: 0.5rem;
    bottom: 0.5rem;
    font-size: 1rem;
  }

  &__expiry-date {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
  }
}

@media (max-width: 30rem) {
  .product-listing {
    justify-content: space-between;

    .card {
      width: 164px;
      height: 164px;
      margin: 0 0 1rem;
    }

    .product-image {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
